export default __webpack_public_path__ + "static/media/377bd1031bf7271e8876a2f47b2ec4081578664506125.1fbefda2.webp";